const MCLID_COOKIE_NAME = 'Mclid';
export const MCLID_METADATA_KEY = 'MCLID';

/**
 * GUS GTM writes a JS cookie named `Mclid` (not HttpOnly) after a paid click.
 * Value is a pipe-joined history of click ids — pass it through as-is.
 */
function decodeCookieValue(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    // Invalid % sequences must not throw — this runs on every sendMessage.
    return value;
  }
}

export function readMclidCookie(cookieString: string): string | undefined {
  if (!cookieString) return undefined;

  const prefix = `${MCLID_COOKIE_NAME}=`;
  const parts = cookieString.split(';');
  for (const part of parts) {
    const trimmed = part.trim();
    if (trimmed.startsWith(prefix)) {
      const value = trimmed.slice(prefix.length);
      return value ? decodeCookieValue(value) : undefined;
    }
  }
  return undefined;
}

export function mergeMclidMetadata(
  metadata: Record<string, string>,
  captureMclidCookie: boolean,
  cookieString: string,
): Record<string, string> | undefined {
  const next = { ...metadata };
  if (captureMclidCookie) {
    const mclid = readMclidCookie(cookieString);
    if (mclid) {
      next[MCLID_METADATA_KEY] = mclid;
    }
  }

  return Object.keys(next).length > 0 ? next : undefined;
}
